/* eslint-disable sonarjs/no-duplicate-string */
import submitBlindForm from './helpers/submitForm.helper'

const loginFormSubmitTarget = '/agillicadmin/j_spring_security_check'
const apiLocation = `${process.env.REACT_APP_CONTEXT}`
const isProduction = `${process.env.REACT_APP_ENVIRONMENT}` === 'prod'

const authenticateWithRemote = ({username, password}) => {
  submitBlindForm({
    route: loginFormSubmitTarget,
    data: [{
      key: 'j_username',
      value: username
    }, {
      key: 'j_password',
      value: password
    }]
  })
}

const authenticateFactorTwoWithRemote = ({username, code}) => {
  submitBlindForm({
    route: loginFormSubmitTarget,
    data: [{
      key: 'j_username',
      value: username
    }, {
      key: 'code',
      value: code
    }]
  })
}

const getSessionFromRemote = ({username, password}) => {
  const formData = new window.FormData()
  formData.append('j_username', username)
  formData.append('j_password', password)
  const data = new window.URLSearchParams(formData)
  return fetch(loginFormSubmitTarget, {
    credentials: 'same-origin',
    method: 'POST',
    body: data
  })
}

const submitNewPassword = ({password}) => {
  if (isProduction) {
    const payload = {password}
    const data = JSON.stringify(payload)
    return fetch(`${apiLocation}/auth/:setNewPassword`, {
      method: 'post',
      body: data,
      credentials: 'include',
      headers: new Headers({'Content-Type': 'application/json'})
    })
  }
  return fetch(`${apiLocation}/submit-new-password-authenticated.json`)
}

const requestNewPasswordFromRemote = ({username}) => {
  if (isProduction) {
    const payload = {username}
    const data = JSON.stringify(payload)
    return fetch(`${apiLocation}/auth/:requestNewPassword`, {
      method: 'post',
      body: data,
      headers: new Headers({'Content-Type': 'application/json'})
    })
  }
  return fetch(`${apiLocation}/request-new-password.json`)
}

const submitAuditMessage = ({auditMessage}) => {
  if (isProduction) {
    const payload = {auditMessage}
    const data = JSON.stringify(payload)
    return fetch(`${apiLocation}/auth/:setAuditMessage`, {
      method: 'post',
      body: data,
      headers: new Headers({'Content-Type': 'application/json'})
    })
  }
  return fetch(`${apiLocation}/ping-success.json`)
}

const requestNewCodeFromRemote = () => (
  isProduction
    ? fetch(`${apiLocation}/v1/security/send`, {credentials: 'include'})
    : fetch(`${apiLocation}/request-new-code.json`))

const fetchPasswordPolicy = () => (
  isProduction
    ? fetch(`${apiLocation}/auth/passwordPolicy`, {headers: new Headers({'Content-Type': 'application/json'}), credentials: 'include'})
    : fetch(`${apiLocation}/password-policy.json`)
)

const fetchSsoInformation = () => (
  isProduction
    ? fetch(`${apiLocation}/auth/ssoInformation`) : fetch(`${apiLocation}/sso-information.json`)
)

const pingInstance = () => (
  isProduction
    ? fetch(`${apiLocation}/auth/instanceInfo`)
    : fetch(`${apiLocation}/ping-success.json`)
)

export {
  authenticateWithRemote,
  authenticateFactorTwoWithRemote,
  requestNewPasswordFromRemote,
  requestNewCodeFromRemote,
  fetchPasswordPolicy,
  fetchSsoInformation,
  submitNewPassword,
  pingInstance,
  getSessionFromRemote,
  submitAuditMessage
}
